import { CommonModule, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-pagination',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss',
})
export class PaginationComponent {
  @Input() currentPage: number = 0;
  @Input() numberOfDevices: number = 366;
  @Input() pageSize: number = 10;
  @Input() lastPageSize: number = Math.ceil(
    this.numberOfDevices / this.pageSize,
  );
  @Output() pageChange = new EventEmitter<number>();

  getEndResult(): number {
    return Math.min(this.currentPage * this.pageSize, this.numberOfDevices);
  }

  getPagesToShow(): number[] {
    const pages: number[] = [];

    if (this.lastPageSize <= 2) {
      for (let i = 1; i <= this.lastPageSize; i++) {
        pages.push(i);
      }
    } else if (this.currentPage === 1) {
      pages.push(1, 2, 3);
    } else if (this.currentPage === this.lastPageSize) {
      pages.push(
        this.lastPageSize - 2,
        this.lastPageSize - 1,
        this.lastPageSize,
      );
    } else {
      const previousPage = Math.max(this.currentPage - 1, 1);
      const nextPage = Math.min(this.currentPage + 1, this.lastPageSize);
      pages.push(previousPage, this.currentPage, nextPage);
    }

    return pages;
  }

  changePage(pagenum: number) {
    if (pagenum < 1) {
      this.currentPage = 1;
    } else if (pagenum > this.lastPageSize) {
      this.currentPage = this.lastPageSize;
    } else {
      this.currentPage = pagenum;
    }
    this.pageChange.emit(this.currentPage);
  }
}
